import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Logo } from "@/components/Logo";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => { setStatus("ok"); refresh(); })
      .catch(() => setStatus("error"));
  }, [token, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="verify-email-page">
      <Card className="w-full max-w-md p-8 glow-border text-center">
        <div className="flex justify-center"><Logo size={26} /></div>
        <div className="mt-8">
          {status === "loading" && <Loader2 className="w-10 h-10 text-primary mx-auto animate-spin" />}
          {status === "ok" && <CheckCircle2 className="w-12 h-12 text-teal-500 mx-auto" data-testid="verify-ok" />}
          {status === "error" && <XCircle className="w-12 h-12 text-red-500 mx-auto" data-testid="verify-error" />}
        </div>
        <h1 className="font-head text-2xl font-bold mt-4">
          {status === "loading" ? "Verifica in corso…" : status === "ok" ? "Email confermata!" : "Link non valido"}
        </h1>
        <p className="text-sm text-muted-foreground mt-2">
          {status === "ok" ? "Il tuo indirizzo email è stato verificato con successo." : status === "error" ? "Il link di conferma non è valido o è già stato utilizzato." : "Attendi qualche istante."}
        </p>
        <Button className="mt-6 w-full" onClick={() => navigate("/app/dashboard")} data-testid="verify-continue-button">Vai alla dashboard</Button>
      </Card>
    </div>
  );
}
